import SpecialOffersPage from './SpecialOffersPage';

export default SpecialOffersPage;
